import type { GetWeekMenuQuery, GetAvailabilitySummaryQuery } from '@/types/api';

export const menuKeys = {
  all: ['menus'] as const,
  week: (params?: GetWeekMenuQuery) => [...menuKeys.all, 'week', params] as const,
  availability: (params: GetAvailabilitySummaryQuery) =>
    [...menuKeys.all, 'availability', params] as const,
};

export const menuSuggestionsKeys = {
  all: ['menu-suggestions'] as const,
  suggestions: (weekStartDate: string) =>
    [...menuSuggestionsKeys.all, weekStartDate] as const,
};

export const menuGenerationKeys = {
  all: ['menu-generation'] as const,
  generate: (weekStart: string) =>
    [...menuGenerationKeys.all, weekStart] as const,
};
